import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { concat, Observable, of } from 'rxjs';
import { IQuotation } from 'src/app/state/quotation/quotation.models';
import { CotizacionService, IQuoteResponse } from '../../http/apiPricing/cotizacion.service';
import { ICotizacionRequest } from '../../interfaces/request/ICotizacionRequest';
import { IObject } from '../../interfaces/response/IObject';
import { IBundle } from '../../interfaces/shared/bundle/IBundle';
import { SessionStorageService } from '../session-storage/session-storage.service';
import { StatusService } from '../status/status.service';
import { UserService } from '../user.service';

export enum QuoteRetarifyActions {
  ONE = "one",
  MULTIPLE = "multiple",
}
export enum Proceso {
  "Contratación y Cartera" = 2,
  "Cotizaciones y Proyectos" = 1001,
  "Canales" = 1002,
  "Oportunidades" = 1003,
  "Documentacion" = 1004,
  "Recibos" = 1006,
  "Siniestros" = 1007,
}
export enum Operativa {
  "Cotizacion" = 3,
  "NuevaProduccion" = 6,
  "Suplemento" = 7,
  "Anulacion" = 9,
  "Renovacion" = 10,
  "NuevoEditarCanal" = 11,
  "NuevaOportunidad" = 12,
  "Rehabilitacion" = 14,
  "CAProyectos" = 19,
  "CACanales" = 20,
  "CAOportunidades" = 22,
  "CAOMovimientos" = 23,
  "FirmaDigital" = 24,
  "GestionRecibo" = 25,
  "Siniestros" = 26,
  "CoberturaON" = 27,
  "Reactivacion" = 29,
}
export enum Canal {
  "Clientes" = 1,
  "Agentes" = 2,
  "Proveedores" = 3,
  "AppMediado" = 4,
}
export enum TipoIdentificacion {
  "CI" = 1,
  "NI" = 2,
  "EX" = 3,
  "PS" = 4,
  "OT" = 5,
}
export enum Empresa {
  "Reale Seguros" = 1,
  "Compania2" = 3,
  "Correduria Contoso" = 4,
}
export enum Riesgo {
  "Accidentes" = 1,
  "Enfermedad" = 2,
  "Asistencia Sanitaria" = 3,
  "Autos" = 4,
  "Transportes" = 5,
  "Incendios" = 6,
  "OtrosDaños" = 7,
  "Credito" = 8,
  "Caucion" = 9,
  "Perdidas Diversas" = 10,
  "Responsabilidad Civil" = 11,
  "Defensa Juridica" = 12,
  "Asistencia" = 13,
  "Decesos" = 14,
  "Multirriesgo Hogar" = 15,
  "Multirriesgo Comunidades" = 16,
  "Multirriesgo Comercios" = 17,
  "Multirriesgo Industriales" = 18,
  "Otros Multirriesgos" = 19,
  "Construcción" = 20,
  "Vida Riesgo" = 21,
}
export enum Clases {
  "ClaseBici" = 1,
  "MaterialBici" = 2,
}

export interface IQuoteData {
  product: IObject;
  partnerCode: string;
  price: number;
  aliasEntidad: string;
  antiguedad?: string;
}


@Injectable({
  providedIn: 'root'
})
export class QuoteService {

  status: IBundle;

  constructor(
    private statusService: StatusService,
    private userService: UserService,
    private cotizationService: CotizacionService,
    private sessionStorageService: SessionStorageService) {
  }

  /**
   * @type {ILastDataBundle}
   * @returns Quote the stored data
   */
  // quote(): Observable<ILastDataBundle> {

  //   const cotizationData = this._createCotizationData();

  //   return this.cotizationService.cotizar(cotizationData).pipe(
  //     map(data => { 
  //       return { cotization: data };
  //     })
  //   );
  // }

  quote(data: IQuoteData): Observable<IQuoteResponse> {
    const cotizationData = this._createCotizationData(data);
    return this.cotizationService.cotizar(cotizationData);
  }

  // chooseRetarifyAction(action: QuoteRetarifyActions, idCotization: any): Observable<any> {
  //   switch (action) {
  //     case QuoteRetarifyActions.ONE:
  //       return this.retarifyOne(idCotization);
  //     case QuoteRetarifyActions.MULTIPLE:
  //       return this.retarifyMultiple();
  //   }
  // }

  // retarifyOne(idCotization: number): Observable<any> {

  //   const data: any = {
  //     idCotizacion: idCotization,
  //     numeroCarrito: (this.statusService.currentIndexObject + 1)
  //   }
    
  //   return this.cotizationService.retarificar(data.idCotizacion, data.numeroCarrito).pipe(
  //     map(retarification => ({ retarification: retarification.data.new }))
  //   )
  // }

  // retarifyMultiple(): Observable<any> {

  //   const bundle = this.statusService.getBundle();

  //   const bindRetarify = bundle.map((obj, index) => {

  //     const data: any = {
  //       idCotizacion: obj.lastData.cotization.idCotizacion,
  //       numeroCarrito: (index + 1)
  //     }

  //     return this.cotizationService.retarificar(data.idCotizacion, data.numeroCarrito) as Observable<any>;
  //   });

  //   return concat(...bindRetarify).pipe(
  //     toArray()
  //   );
  // }

  /**
   * Generate quote's data to fit to the API request body
   * @returns The quote related data
   */
  private _createCotizationData(data: IQuoteData): ICotizacionRequest {
    return {
      procesoBase: {
        idProceso: Proceso['Cotizaciones y Proyectos'],
        idOperativa: Operativa.Cotizacion,
        idCanal: Canal.Agentes,
        idProducto: data.product.idProducto,
        aliasEntidad: data.aliasEntidad
      },
      cotizacion: {
        tipoIdentificacion: TipoIdentificacion.NI,
        idEmpresa: Empresa['Reale Seguros'],
        idCategoria: data.product.idcategoria,
        idCanal: Canal.AppMediado,
        fechaNacimiento: moment('01/01/2000').format('YYYY-MM-DD'),
        CodigoPostal: 46400,
        ...(data.product.idProducto === 1054 && { idModalidad: 51 })
      },
      riesgos: [
        {
          descripcion: data.product.descripcion,
          idRiesgo: Riesgo['Otros Multirriesgos'],
          idObjeto: data.product.id,
          valorOriginal: data.price,
          antiguedad: moment(data.antiguedad).format('YYYY-MM-DD')
        }
      ]
    };
  }
}
